import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatDateForTransaction } from "@helpers/date";
import styles from "./UploadDateCell.module.scss";

export const UploadDateCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, FinancialDocumentListItem, Date>) => (
        <ViewTableCell className={styles.dateCell}>
            {formatDateForTransaction(getValue())}
        </ViewTableCell>
    ),
);
